import { FC, useMemo, useRef } from "react"
import { Fragment } from "react/jsx-runtime"
import { getAcceptFromFileMineType, LibraryViewMode } from "."
import { apiFileRemove, apiFileUpload, apiFolderCreate, apiFolderRemove, apiFolderUpdate, FileMineType, FolderItemProps } from "apis";
import { ContextMenuData, OnContextMenuProps, SelectedItemType } from "./";
import { AppAlert } from "components";
import FormFolder from "./FormFolder";

interface ItemFolderProps {
    viewMode: LibraryViewMode;
    item: FolderItemProps;
    onContextMenu: OnContextMenuProps;
    contextMenuData: ContextMenuData;
    onDoubleClick: (item: FolderItemProps) => void;
    onContextMenuClose: () => void;

    selecteds: SelectedItemType[];
    onSelect: React.Dispatch<React.SetStateAction<SelectedItemType[]>>;

    multiple?: boolean;
    allowSelect?: boolean;

    minType?: FileMineType[];
}
const ItemFolder: FC<ItemFolderProps> = ({ viewMode, item, contextMenuData, onContextMenu, onDoubleClick, selecteds, onSelect, onContextMenuClose, multiple, allowSelect, minType }) => {

    const ref = useRef<HTMLUListElement>(null);
    const isSelected = useMemo(() => {
        return selecteds.findIndex(s => s.type === "folder" && s.item.id === item.id) >= 0;
    }, [selecteds, item])

    const wrapperClassName = useMemo(() => {
        switch (viewMode) {
            case "grid":
                return `flex flex-col items-center p-3 border rounded hover:bg-gray-100 cursor-pointer relative ${isSelected ? " border-blue-500 bg-gray-200" : ""}`;
            case "list":
                return `flex items-center space-x-3 p-2 hover:bg-gray-50 cursor-pointer relative ${isSelected ? " bg-gray-100" : ""}`;
            default:
                return "";
        }
    }, [viewMode, isSelected])
    const labelClassName = useMemo(() => {
        switch (viewMode) {
            case "grid":
                return "mt-2 text-sm text-center truncate w-full select-none";
            case "list":
                return "truncate select-none";
            default:
                return "select-none";
        }
    }, [viewMode])

    const folderSelecteds = selecteds.filter(s => s.type === "folder");
    const fileSelecteds = selecteds.filter(s => s.type === "file");

    const inputFileRef = useRef<HTMLInputElement>(null);
    return <Fragment>
        <input
            type="file"
            ref={inputFileRef}
            hidden
            multiple
            onChange={async (e) => {
                if (e.target.files) {
                    const files: any = e.target.files;
                    const res = await apiFileUpload({ files: files, folderId: item.id });
                }
                e.target.value = "";
            }}
            accept={getAcceptFromFileMineType(minType)}

        />
        <div
            onClick={(e) => {
                if (allowSelect) {
                    if (e.ctrlKey && multiple) {
                        onSelect(selecteds => {
                            if (selecteds.findIndex(s => s.type === "folder" && s.item.id === item.id) >= 0) {
                                return selecteds.filter(s => s.type !== "folder" || s.item.id !== item.id);
                            }
                            return [...selecteds, { item, type: "folder" }];
                        });
                    }
                    else {
                        onSelect([{ item, type: "folder" }]);
                    }
                }
            }}
            onDoubleClick={() => onDoubleClick(item)}
            onContextMenu={(e) => onContextMenu(e, ref, { item, type: "folder" })}
            className={wrapperClassName}
        >
            <i className="fa fa-folder text-yellow-500 text-3xl" />
            <span className={labelClassName}>
                {item.name}
            </span>
            <ul
                ref={ref}
                onContextMenu={e => e.stopPropagation()}
                className="fixed bg-white border rounded shadow-lg w-40 z-50 max-h-[calc(100vh-10px)] overflow-y-auto"
                style={{
                    top: contextMenuData?.y ?? 0,
                    left: contextMenuData?.x ?? 0,
                    opacity: contextMenuData && contextMenuData.item?.type === "folder" && contextMenuData.item?.item.id === item.id ? 1 : 0,
                    pointerEvents: contextMenuData && contextMenuData.item?.type === "folder" && contextMenuData.item?.item.id === item.id ? "auto" : "none",
                }}
            >
                <li
                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                    onClick={(e) => {
                        const modalInstance = AppAlert.modal({
                            title: "Nhập tên thư mục",
                            content: <div className="w-[500px]">
                                <FormFolder
                                    onClose={() => modalInstance.close()}
                                    onSubmit={async (values) => {
                                        const res = await apiFolderCreate({ ...values, parentId: item.id });
                                        if (res.status) {
                                            modalInstance.close();
                                        }
                                    }}
                                />
                            </div>
                        });
                    }}
                >
                    Thêm thư mục
                </li>
                <li
                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                    onClick={() => inputFileRef.current?.click()}
                >
                    Thêm file
                </li>
                <li
                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                    onClick={(e) => {
                        const modalInstance = AppAlert.modal({
                            title: "Nhập tên thư mục",
                            content: <div className="w-[500px]">
                                <FormFolder
                                    initialValues={item}
                                    onClose={() => modalInstance.close()}
                                    onSubmit={async (values) => {
                                        const res = await apiFolderUpdate({ ...item, parentId: item.parent?.id, name: values.name });
                                        if (res.status) {
                                            modalInstance.close();
                                        }
                                    }}
                                />
                            </div>
                        });
                    }}
                >
                    Đổi tên
                </li>
                <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">Sao chép</li>
                <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">Dán</li>
                <li
                    className="px-4 py-2 hover:bg-red-100 text-red-600 cursor-pointer"
                    onClick={(e) => {
                        e.stopPropagation();
                        onContextMenuClose();
                        AppAlert.confirm({
                            title: "Bạn chắc chắn muốn xoá",
                            content: <div>
                                {
                                    folderSelecteds.findIndex(folderSelected => folderSelected.item.id === item.id) >= 0 ?
                                        <Fragment>

                                            {folderSelecteds.length > 0 && <div className="font-bold">Thư mục</div>}
                                            {folderSelecteds.map(item => <div>
                                                - {item.item.name}
                                            </div>)}
                                            {fileSelecteds.length > 0 && <div className="font-bold">Tài liệu</div>}
                                            {fileSelecteds.map(item => <div>
                                                - {item.item.name}
                                            </div>)}
                                        </Fragment> :
                                        <Fragment>
                                            <div className="font-bold">Thư mục</div>
                                            <div>- {item.name}</div>
                                        </Fragment>
                                }
                            </div>,
                            onOk: async () => {
                                if (folderSelecteds.findIndex(folderSelected => folderSelected.item.id === item.id) >= 0) {
                                    await Promise.all([
                                        folderSelecteds.length > 0 ? apiFolderRemove({ ids: folderSelecteds.map(item => item.item.id) }) : undefined,
                                        fileSelecteds.length > 0 ? apiFileRemove({ ids: fileSelecteds.map(item => item.item.id) }) : undefined
                                    ]);
                                }
                                else {
                                    await apiFolderRemove({ ids: [item.id] });
                                }
                            },
                        })
                    }}
                >
                    Xóa
                </li>
            </ul>
        </div>
    </Fragment >
}

export default ItemFolder;